import React from "react";
import { useEffect, useState, useId } from "react";

import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  PDFDownloadLink,
  Image,
  Font,
} from "@react-pdf/renderer";
import Logo from "../../../../assets/img/Dwelly_FullLogo_Transparent.png";
import moment from "moment";
import FontVerdana from "../../../../assets/fonts/Verdana.ttf";
import FontVerdanaBold from "../../../../assets/fonts/Verdana Bold.ttf";
import FontVerdanaItalic from "../../../../assets/fonts/Verdana Italic.ttf";
import FontVerdanaBoldItalic from "../../../../assets/fonts/Verdana Bold Italic.ttf";
import DealCalculations from "./DealCalculations";
import { fetchListingDetails } from "../../../../common/listing-converter";
import { Button, Select } from "@chakra-ui/react";
import {  upperFirst, filter, startCase, set } from "lodash";

import { FormatCurrencyPlain, round2 } from "./trustReconciliationUtils";
Font.register({
  family: "Verdana",
  fonts: [
    { src: FontVerdana },
    { src: FontVerdanaBold, fontWeight: "bold" },
    { src: FontVerdanaItalic, fontStyle: "italic" },
    { src: FontVerdanaBoldItalic, fontWeight: "bold", fontStyle: "italic" },
  ],
});
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    fontFamily: "Verdana",
    padding: 20,
  },
  text: {
    fontSize: 10,
  },
  body: {
    fontSize: 12,
  },
  section: {
    margin: 10,
    padding: 10,
    paddingLeft: 25,
    paddingRight: 25,
  },
});

// Create Document Component
const formatCurrency = (amount) => {
  return FormatCurrencyPlain(amount);
};
const Invoice = ({ deal, allAgents }) => {
  const [mlsData, setMlsData] = useState(null);
  const [type, setType] = useState("buyer");
  const [lawyer, setLawyer] = useState(null);
  useEffect(() => {
    if (deal && !mlsData) {
      getMLSListingDetails(deal.MLS);
    }
  }, [deal]);
  async function getMLSListingDetails(MLS) {
    let toSend = await fetchListingDetails(MLS);
    if (!toSend) {
      console.log("WRONG MLS");
    }
    if (toSend) {
      setMlsData(toSend);
    }
    console.log({ toSend });
    return toSend;
  }
  useEffect(() => {
    if(type === "buyer" && deal && deal.buyer_lawyers && deal.buyer_lawyers.length > 0) {
      setLawyer(deal.buyer_lawyers[0]);
    } else if(type === "seller" && deal && deal.seller_lawyers && deal.seller_lawyers.length > 0) {
      setLawyer(deal.seller_lawyers[0]);
    }
  }, [type, deal]);
  const price = parseFloat(deal.sale_price);
  const commission =
    (parseFloat(deal.sale_price) * parseFloat(deal.total_commission_buyagent)) /
    100;
  const hst = (commission * 13) / 100;
  const {
    agents,
    primaryAgent,
    dwellyRebate,
    otherAgents,
    salePrice,
    buyerCommissionPercentage,
    sellerCommissionPercentage,
    totalCommissionPercentage,
    buyerCommission,
    sellerCommission,
    primaryAgentCommission,
    totalCommission,
    totalCommissionHST,
    otherAgentCommissions,
    primaryAgentEmail,
    primaryAgentInfo,
    coopRebate,
    sellerRebate,
    agentComissions,
    totalAgentCommissions,
    officeCommission,
    personaSaleFee,
    HST,
    isco_op,
    rebate,
    hasRebate,
    Comission,
    Expenses,
    BaseOfficeCommission,
    AgentsLines,
    AgentTotalsLine,
    NetOfficeLine,
  } = DealCalculations(deal, allAgents);
  console.log({ commission, hst, mlsData, deal });
  const types = ["buyer", "seller"];

  const document = (
    <Document>
      <Page size={"LETTER"} style={styles.page}>
        <View style={styles.section}>
          <Image style={{ width: "30%" }} src={Logo} />
          <Text style={styles.text}>{"Dwelly Realy Inc., Brokerage"}</Text>
          <Text style={styles.text}>
            {"200-55 Village Center Pl, Mississauga, ON L4Z 1V9 CA"}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={{ ...styles.text }}>
            {moment().format("LL")}
          </Text>
          <Text style={{ ...styles.text, top: 20 }}>
            {lawyer?.company_name}
          </Text>
          <Text style={{ ...styles.text, top: 20 }}>
            {lawyer?.name}
          </Text>
          <Text style={{ ...styles.text, top: 20 }}>
            {lawyer?.address}
          </Text>
          <Text style={{ ...styles.text, top: 20 }}>
            {lawyer?.phone}
          </Text>
          <Text
            style={{
              ...styles.text,
              top: 30,
              fontWeight: "extrabold",
              fontSize: 14,
            }}
          >
            Re: Agreement of Purchase and Sale
          </Text>
          <Text style={{ ...styles.text, top: 35, left:30,
              fontSize: 11, }}>{deal.address}</Text>
          <Text style={{ ...styles.text, top: 40, left:30,
              fontSize: 11, }}>Buyers: {deal.buyers.map((seller) => seller.name).join(", ")}</Text>
          <Text style={{ ...styles.text, top: 45, left:30,
              fontSize: 11, }}>Closing Date: {moment(deal.closing_date).format("LL")}</Text>
          <Text style={{ ...styles.text, top: 55, left:30,
              fontSize: 11, }}>Purchase Price: <Text>             {formatCurrency(parseFloat(deal.sale_price))}</Text></Text>
          <Text style={{ ...styles.text, top: 55, left:30,
              fontSize: 11, }}>Commission {totalCommissionPercentage}%:         {formatCurrency(totalCommission)}</Text>
          <Text style={{ ...styles.text, top: 55, left:30,
              fontSize: 11, }}>HST:                              {formatCurrency(totalCommissionHST)}</Text>
          <Text style={{ ...styles.text, top: 55, left:30,
              fontSize: 11, }}>Deposit Held In Trust:      {formatCurrency(parseFloat(deal.buyer_deposit))}</Text>
          <Text style={{ ...styles.text, top: 55, left:30, fontWeight:"bold",
              fontSize: 11, }}>Balance Due to Seller:    {formatCurrency(round2(parseFloat(deal.buyer_deposit || 0) - totalCommission - totalCommissionHST))}</Text>
          <Text style={{ ...styles.text, top: 55, left:30, fontWeight:"bold", textDecoration:"underline", textDecorationStyle:"solid",textDecorationWeight:"2px",
              fontSize: 11, }}>------------------------------------------------------------------------</Text>
             
        </View>
        <Text
            style={{
              ...styles.section,
              fontStyle: "italic",
              marginTop: 100,fontSize:10
            }}
          >
            Please be advised upon completion of this sale, we will notify our Listing Agent for instructions regarding the balance of
commission due to the Seller. If you have any concerns or questions, please contact us at the numbers below.
          </Text>
       
        <View style={styles.section}>
          <Text
            style={{
              ...styles.text,
              marginTop: 20,
            }}
          >
            Yours truly
          </Text>
          <Text
            style={{
              ...styles.text,
              top: 45,
            }}
          >
            {"\n"}Dwelly Admin
          </Text>
          <Text
            style={{
              ...styles.text,
              top: 45,
            }}
          >
            {"\n"}E. & O. E.
          </Text>
          
          

          <Text
            style={{
              ...styles.text,
              textAlign: "center",
              marginTop: 40,
            }}
          >
            {"\n"}
            <Text style={{ fontWeight: "bold" }}>
              Dwelly Realty Inc., Brokerage
            </Text>
            {"\n"}200-55 Village Center Pl, Mississauga, ON L4Z 1V9 CA {"\n"}
            Tel: 647.797.1133 -- Email: deals@dwellyrealty.com
          </Text>
        </View>
      </Page>
    </Document>
  );
  return (
    mlsData && (
      <>
      <Select
                variant="outline"
                onChange={(e) => setType(e.target.value)}
                value={type}
              >
                {types.map((type, index) => (
                  <option key={"cheque_option_" + index} value={type}>
                    {upperFirst(type)}
                  </option>
                ))}
              </Select>
        <PDFDownloadLink
          style={{ position: "absolute", top: 20, right: 50 }}
          document={document}
          fileName={"commission_statement_" +type+"_"+ deal.deal_id + "_" + deal._id + ".pdf"}
        >
          {({ blob, url, loading, error }) =>
            loading ? "Loading document..." : "Download now!"
          }
        </PDFDownloadLink>
        <PDFViewer style={{ flexGrow: 1, width: "100%", height: "90vh" }}>
          {document}
        </PDFViewer>
      </>
    )
  );
};
export default Invoice;
